<template>
  <iframe
    :title="$t('branding.previewConfirmation')"
    :srcdoc="previewHtml"
    sandbox
  />
</template>

<script setup>
// @ts-check
import { computed } from 'vue';

import { useContrastColour } from '@/composables/utils/colour';

import signedPreview from '@/assets/signedPreview.html';

const props = defineProps({
  logo: {
    type: String,
    required: true,
  },
  colour: {
    type: String,
    required: true,
  },
  colourIsWhite: {
    type: Boolean,
    required: true,
  },
  /** @type {import('vue').PropOptions<import('@/composables/utils/colour/useContrastColour').Hex | null>} */
  colourAccent: {
    required: false,
  },
  companyName: {
    type: String,
    required: true,
  },
});

const colourContrast = useContrastColour(computed(() => props.colourAccent || '#10dac1'));

const styles = computed(() => `<style>
  :root {
    --colour: ${props.colour};
    --colourAccent: ${props.colourAccent || '#3fe4fb'};
    --colourSuccess: ${props.colourAccent || '#10dac1'};
    --colourContrast: ${props.colourAccent ? colourContrast.value : '#ffffff'};
    --whiteOrGray: ${props.colourIsWhite ? '#fafafa' : '#ffffff'};
  }
</style>`);

const previewHtml = computed(() => {
  const withStyle = styles.value + signedPreview;
  const replaced = withStyle
    .replace('%logo%', props.logo)
    .replace('%company_name%', props.companyName);

  return replaced;
});
</script>
